import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AiCompetitorsStepIntro = ({
  stepNumber,
  title,
  mutedTitle,
  description,
  backLabel,
  onBack,
}) => (
  <Box>
    {onBack || stepNumber ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, sm: 2 },
          mb: { xs: 1.5, sm: 2 },
          flexWrap: "wrap",
        }}
      >
        {onBack ? (
          <Button
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onBack();
            }}
            startIcon={<ArrowBackIcon sx={{ fontSize: 14 }} />}
            sx={{
              minWidth: 0,
              px: 0,
              py: 0,
              fontFamily: "monospace",
              fontSize: 10,
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              color: "text.secondary",
              "& .MuiButton-startIcon": {
                mr: 0.75,
                "& > *:nth-of-type(1)": { fontSize: 14 },
              },
            }}
          >
            {backLabel}
          </Button>
        ) : null}
        {stepNumber ? (
          <Typography
            component="p"
            sx={{
              fontFamily: "monospace",
              fontSize: 10,
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              color: "text.secondary",
            }}
          >
            {stepNumber}
          </Typography>
        ) : null}
      </Box>
    ) : null}
    <Typography
      component="h1"
      sx={{
        fontSize: { xs: 28, sm: 48 },
        fontWeight: 600,
        lineHeight: 1.1,
        letterSpacing: { xs: "-0.04em", sm: "-0.055em" },
        textWrap: "balance",
      }}
    >
      {title}
      <br />
      <Box component="span" sx={{ color: "text.secondary" }}>
        {mutedTitle}
      </Box>
    </Typography>
    {description ? (
      <Typography
        sx={{
          mt: { xs: 1.5, sm: 3 },
          maxWidth: 576,
          fontSize: { xs: 14, sm: 16 },
          lineHeight: { xs: 1.55, sm: 1.75 },
          color: "text.secondary",
        }}
      >
        {description}
      </Typography>
    ) : null}
  </Box>
);

export default AiCompetitorsStepIntro;
